export enum ELieuPrelevementSurface
{
    TableOperation = 1,
    Scialytique = 2,
    TableInstruments = 3,
    ChariotAnesthesie = 4,
    Respirateur = 5,
    ChariotInox = 6,
    BistouriElectrique = 7,
    Autre = 8,
    ParoiGauche = 9,
    ParoiDroite = 10,
    Sol = 11,
    SupportEndoscope = 12
}